const _import = require('../import-' + process.env.NODE_ENV)

const marketResearchRouter = [
  {
    path: '/marketResearch/index',
    name: 'marketResearchIndex',
    component: _import('marketResearch/index'),
    meta: {
      auth: true,
      title: '商品市调',
      keepAlive: true
    }
  },
  {
    path: '/marketResearch/running',
    name: 'marketResearchRunning',
    component: _import('marketResearch/running'),
    meta: {
      auth: true,
      title: '商品市调',
      keepAlive: true
    }
  },
  {
    path: '/marketResearch/progress',
    name: 'marketResearchProgress',
    component: _import('marketResearch/progress'),
    meta: {
      auth: true,
      title: '商品市调'
    }
  },
  {
    path: '/marketResearch/submit',
    name: 'marketResearchSubmit',
    component: _import('marketResearch/submit'),
    meta: {
      auth: true,
      title: '商品市调'
    }
  },
  {
    path: '/marketResearch/inputLog',
    name: 'marketResearchIndexInputLog',
    component: _import('marketResearch/inputLog'),
    meta: {
      auth: true,
      title: '商品市调'
    }
  },
  {
    path: '/marketResearch/reports',
    name: 'marketResearchReports',
    component: _import('marketResearch/reports'),
    meta: {
      auth: true,
      title: '市调结果'
    }
  },
  {
    path: '/marketResearch/excluted',
    name: 'marketResearchExcluted',
    component: _import('marketResearch/excluted'),
    meta: {
      auth: true,
      title: '商品市调',
      keepAlive: true
    }
  }
]
export default marketResearchRouter



// WEBPACK FOOTER //
// ./src/router/work/marketResearch.js